// Exports
export default {
	"peer": "peer_yYKlp",
	"peerDisplayName": "peerDisplayName_bNw0u"
};
